<script lang="ts" setup>
import constants from '~/constants'
import helpers from '~/helpers'
import { useCartStore } from '~/store/cart'

withDefaults(
  defineProps<{
    title: string,
    withTotal?: boolean,
  }>(),
  { withTotal: true }
)
const cartStore = useCartStore()
</script>

<template>
  <div class="flex items-center md:items-end">
    <h1 class="!mb-0 text-[28px] font-medium leading-none text-main-dark md:text-[44px] md:leading-[109%]">
      {{ title }}
    </h1>

    <p
      v-if="!cartStore.isDataLoading && !cartStore.isDataLoading2 && withTotal"
      class="
        ml-2 flex !size-5 items-center rounded-full bg-main-green text-center text-sm font-medium tracking-[-0.01em]
        text-white md:mb-1 md:size-auto md:rounded-none md:bg-transparent md:text-left md:text-base md:font-normal md:text-main-dark md:opacity-[.4]
      "
    >
      <span class="mx-auto inline-block">
        {{ cartStore.totalItems }}
      </span>

      <span class="ml-1 hidden md:inline-block">
        {{ helpers.getDeclension(cartStore.totalItems, constants.wordForms.product) }}
      </span>
    </p>
  </div>
</template>
